"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../../axios-client/axios-client.service");
var user_company_user_account_const_1 = require("./user-company-user-account.const");
/**
 * UserCompanyUserAccount
 * @class
 */
var UserCompanyUserAccount = /** @class */ (function () {
    function UserCompanyUserAccount() {
    }
    /**
     * Creates a new user
     * @param data<User>
     * @returns
     */
    UserCompanyUserAccount.prototype.createUser = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_account_const_1.USER_COMPANY_USER_ACCOUNT_ENDPOINT.createUser.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Returns user details for provided `idp`
     * @param idp {string}
     * @returns
     */
    UserCompanyUserAccount.prototype.getUserDetailFromIdp = function (idp, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_account_const_1.USER_COMPANY_USER_ACCOUNT_ENDPOINT.getUserDetailFromIdp
            .replace('{{version}}', version)
            .replace('{{idpUuid}}', idp);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns user details for provided `userUuid`
     * @param userUuid {string}
     * @returns
     */
    UserCompanyUserAccount.prototype.getUserAccount = function (userUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_account_const_1.USER_COMPANY_USER_ACCOUNT_ENDPOINT.getUserAccount
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates a given user (`userUuid`) with new `data`object
     * @param userUuid {string}
     * @param data Partial<User>
     * @returns
     */
    UserCompanyUserAccount.prototype.updateUser = function (userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_account_const_1.USER_COMPANY_USER_ACCOUNT_ENDPOINT.updateUser
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Updates a given user's (`userUuid`) password
     * @param user {string}
     * @param data Partial<User>
     * @returns
     */
    UserCompanyUserAccount.prototype.updatePassword = function (userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_user_account_const_1.USER_COMPANY_USER_ACCOUNT_ENDPOINT.updatePassword
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    return UserCompanyUserAccount;
}());
/**
 * External UserCompanyUserAccount Class Instance
 * @namespace
 */
exports.userCompanyUserAccount = new UserCompanyUserAccount();
